import { api } from './client.js';

export const versions = {
  list:    ()           => api.get('/versions'),
  get:     (id)         => api.get(`/versions/${id}`),
  create:  (body)       => api.post('/versions', body),
  remove:  (id)         => api.delete(`/versions/${id}`),
  compare: (aId, bId)   => api.get('/versions/compare', { query: { a: aId, b: bId } }),
};
